import AILoadingSpinner from "@/components/AIComponents/AILoadingSpinner";
import { useExportablesModalContext } from "@/components/AIComponents/ExportablesModal/ExportablesModalContext/useExportablesModalContext";
import ExportablesArticlePreview from "./ExportablesArticlePreview";
import {
  bodyWrapperCss,
  galleryPreviewWrapperCss,
  instructionsCss,
  loadingSpinnerWrapperCss,
  loadingWrapperCss,
} from "./ExportablesModalBody.styles";
import ExportablesTemplateGallery from "./ExportablesTemplateGallery";
import ExportablesTemplatePreview from "./ExportablesTemplatePreview";

interface ExportablesModalBodyProps {
  isStudent: boolean;
}

const ExportablesModalBody = ({ isStudent }: ExportablesModalBodyProps) => {
  const { isInAssignGraphicOrganizersExperiment, isLoading } =
    useExportablesModalContext();

  const instructions = isStudent
    ? "Your teacher has assigned you the graphic organizers below, you can type directly into them. Closing this window before submitting will delete any progress."
    : "Select the graphic organizers you want to assign or download as a PDF.";

  const showInstructions = isStudent || isInAssignGraphicOrganizersExperiment;

  return isLoading ? (
    <div css={loadingWrapperCss}>
      <AILoadingSpinner __cssFor={{ root: loadingSpinnerWrapperCss }} />
    </div>
  ) : (
    <div css={bodyWrapperCss(showInstructions)}>
      {showInstructions && <p css={instructionsCss}>{instructions}</p>}

      <div css={galleryPreviewWrapperCss(isStudent)}>
        {isStudent ? (
          <ExportablesArticlePreview />
        ) : (
          <ExportablesTemplateGallery />
        )}
        <ExportablesTemplatePreview isStudent={isStudent} />
      </div>
    </div>
  );
};

export default ExportablesModalBody;
